var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGourmet = function SvgGourmet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 3.75a7.92 7.92 0 0 0-7.385 5.068 7.918 7.918 0 0 0-3.865 15.2V35c0 .69.56 1.25 1.25 1.25h20c.69 0 1.25-.56 1.25-1.25V24.018a7.918 7.918 0 0 0-3.862-15.2A7.92 7.92 0 0 0 20 3.75m-3.398 3.7a5.417 5.417 0 0 1 8.693 3.066 1.25 1.25 0 0 0 1.548.942 5.417 5.417 0 1 1 2.83 10.459 1.25 1.25 0 0 0-.923 1.206v3.961l-17.5.013v-3.974a1.25 1.25 0 0 0-.923-1.206 5.419 5.419 0 0 1 2.833-10.459 1.25 1.25 0 0 0 1.548-.941 5.42 5.42 0 0 1 1.894-3.067M11.25 29.597v4.153h17.5v-4.166z",
    clipRule: "evenodd"
  })));
};
export default SvgGourmet;